import { render } from "./DocHome.vue?vue&type=template&id=374cade6&scoped=true&ts=true"
import script from "./DocHome.vue?vue&type=script&lang=ts"
export * from "./DocHome.vue?vue&type=script&lang=ts"

import "./DocHome.vue?vue&type=style&index=0&id=374cade6&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374cade6"]])

export default __exports__